import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { apiErrorMessage } from "@/lib/apiError";
import { Globe, Hash } from "lucide-react";
import { SectionCard, TextRow, ListEditor, RowsEditor } from "@/components/Brand/editors";

export default function BrandDigitalTab({ brand, onSaved }) {
  const [digital, setDigital] = useState(brand.digital || {});
  const [busy, setBusy] = useState(false);
  const setD = (k, v) => setDigital((s) => ({ ...s, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/brands/${brand.id}`, { digital });
      toast.success("Saved");
      onSaved?.();
    } catch (e) { toast.error(apiErrorMessage(e, "Save failed")); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4" data-testid="brand-digital-tab">
      <SectionCard title="Digital presence" icon={Globe} onSave={save} busy={busy} testid="brand-presence-section">
        <RowsEditor label="Social handles"
          columns={[
            { key: "platform", label: "Platform", type: "select", options: ["instagram", "facebook", "linkedin", "x", "youtube", "tiktok", "pinterest", "gmb", "other"] },
            { key: "handle", label: "Handle" },
            { key: "url", label: "URL" },
          ]}
          rows={digital.socials || []} onChange={(v) => setD("socials", v)} addLabel="Add handle" testid="socials" />
        <ListEditor label="SEO keyword list" items={digital.seo_keywords || []} onChange={(v) => setD("seo_keywords", v)} placeholder="e.g. artisanal coffee pune" testid="seo-keywords" />
        <TextRow label="Compliance / legal notes" value={digital.compliance_notes} onChange={(v) => setD("compliance_notes", v)} multiline testid="compliance-notes" />
      </SectionCard>

      <SectionCard title="Content banks" icon={Hash} onSave={save} busy={busy} testid="brand-banks-section">
        <RowsEditor label="Hashtag banks"
          columns={[{ key: "label", label: "Bank name" }, { key: "tags", label: "Hashtags (comma-separated)", type: "textarea" }]}
          rows={digital.hashtag_banks || []} onChange={(v) => setD("hashtag_banks", v)} addLabel="Add bank" testid="hashtag-banks" />
        <ListEditor label="CTA bank" items={digital.cta_bank || []} onChange={(v) => setD("cta_bank", v)} placeholder="e.g. Order now on Swiggy" testid="cta-bank" />
      </SectionCard>
    </div>
  );
}
